import { Alert, Snackbar } from "@mui/material";

const BaseSnackbar = (props) => {
    const { show, onClose, message, backgroundColor } = props; // Add backgroundColor and padding props

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={show}
            autoHideDuration={5000}
            onClose={onClose}
        >
            <Alert icon={false} onClose={onClose} sx={{ width: 1230, padding: {xs: "15px", md: "32px 24px 32px 48px"}, backgroundColor: backgroundColor }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default BaseSnackbar;
